import ProcessTerminate from './ProcessTerminate';

export default ProcessTerminate;
